import React from "react";
import styles from "./StoreSelect.module.scss";
import { Link } from "react-router-dom";

const StoreSelect: React.FC<{
  stores?: { id: string; name: string }[];
}> = ({ stores }) => {
  return stores?.length ? (
    <div className="flex flex-col gap-4">
      {stores.map((store) => (
        <Link key={store.id} className={styles.link} to={`/stores/${store.id}`}>
          {store.name}
        </Link>
      ))}
    </div>
  ) : null;
};

export default StoreSelect;
